import Vue from 'vue'
import Router from 'vue-router'
import AuthLayout from '@/layouts/Auth'
import AppLayout from '@/layouts/App'
import AppDashboard from '@/views/dashboard/analytics'
import { authGuard } from '@/plugins/auth/guard'

Vue.use(Router)

const router = new Router({
    base: '/',
    mode: 'history',
    scrollBehavior() {
        return { x: 0, y: 0 }
    },
    routes: [{
            path: '/completing',
            meta: { authRequired: true, authorizedRole: ['admin', 'owner'] },
            component: AuthLayout,
            children: [{
                path: '',
                meta: {
                    title: 'Complete Cadastro',
                },
                component: () =>
                    import ('./views/system/completion'),
            }],
        },
        {
            path: '/',
            component: AppLayout,
            meta: { authRequired: true, hidden: true, authorizedRole: ['admin', 'owner'] },
            children: [{
                    path: '/',
                    meta: {
                        title: 'Resumo de Vendas',

                    },
                    component: AppDashboard,
                },
                {
                    path: '/dashboard',
                    meta: {
                        title: 'Resumo de Vendas',

                    },
                    component: AppDashboard,
                },
                {
                    path: '/integrations/active_campaign/:id',
                    meta: {
                        title: 'Rules',
                    },
                    component: () =>
                        import ('./views/marketplace/integrations/ActiveCampaign/Rules'),
                },
                {
                    path: '/integrations',
                    meta: {
                        title: 'Links',
                    },
                    component: () =>
                        import ('./views/marketplace/integrations/List'),
                },
                {
                    path: '/marketplace/links/:product',
                    meta: {
                        title: 'Links',
                    },
                    component: () =>
                        import ('./views/marketplace/links'),
                },
                {
                    path: '/marketplace/products',
                    meta: {
                        title: 'Ofertas',
                    },
                    component: () =>
                        import ('./views/marketplace/product'),
                },
                {
                    path: '/marketplace/products/create',
                    meta: {
                        title: 'Ofertas',
                    },
                    component: () =>
                        import ('./views/marketplace/product/create'),
                },
                {
                    path: '/marketplace/products/:id/edit',
                    meta: {
                        title: 'Ofertas',
                    },
                    component: () =>
                        import ('./views/marketplace/product/edit'),
                },
                {
                    path: '/ecommerce/carts',
                    meta: {
                        title: 'Carrinhos Dinâmicos',
                    },
                    component: () =>
                        import ('./views/ecommerce/carts'),
                },
                {
                    path: '/ecommerce/carts/create',
                    meta: {
                        title: 'Carrinhos Dinâmicos',
                    },
                    component: () =>
                        import ('./views/ecommerce/carts/create'),
                },
                {
                    path: '/ecommerce/carts/:id/edit',
                    meta: {
                        title: 'Editar Carrinho',
                    },
                    component: () =>
                        import ('./views/ecommerce/carts/edit'),
                },
                {
                    path: '/ecommerce/balance',
                    meta: {
                        title: 'Extratos',
                    },
                    component: () =>
                        import ('./views/ecommerce/balance'),
                },
                {
                    path: '/ecommerce/offer',
                    meta: {
                        title: 'Grupos',
                    },
                    component: () =>
                        import ('./views/ecommerce/offer'),
                },
                {
                    path: '/ecommerce/offer/create',
                    meta: {
                        title: 'Criar Grupo',
                    },
                    component: () =>
                        import ('./views/ecommerce/offer/create'),
                },
                {
                    path: '/ecommerce/offer/:id/edit',
                    meta: {
                        title: 'Editar Grupo',
                    },
                    component: () =>
                        import ('./views/ecommerce/offer/edit'),
                },
                {
                    path: '/ecommerce/webhook',
                    meta: {
                        title: 'Webhooks',
                    },
                    component: () =>
                        import ('./views/ecommerce/webhook'),
                },
                {
                    path: '/ecommerce/webhook/:id/view',
                    meta: {
                        title: 'Informações Webhook',
                    },
                    component: () =>
                        import ('./views/ecommerce/webhook/view'),
                },
                {
                    path: '/ecommerce/webhook/:id/edit',
                    meta: {
                        title: 'Editar Webhook',
                    },
                    component: () =>
                        import ('./views/ecommerce/webhook/edit'),
                },
                {
                    path: '/ecommerce/webhook/create',
                    meta: {
                        title: 'Criar Webhook',
                    },
                    component: () =>
                        import ('./views/ecommerce/webhook/create'),
                },
                {
                    path: '/ecommerce/product',
                    meta: {
                        title: 'Produtos',
                    },
                    component: () =>
                        import ('./views/ecommerce/product'),
                },
                {
                    path: '/ecommerce/product/:id/edit',
                    meta: {
                        title: 'Editar Produto',
                    },
                    component: () =>
                        import ('./views/ecommerce/product/edit'),
                },
                {
                    path: '/ecommerce/product/create',
                    meta: {
                        title: 'Criar Produto',
                    },
                    component: () =>
                        import ('./views/ecommerce/product/create'),
                },
                {
                    path: '/ecommerce/checkout',
                    meta: {
                        title: 'Ofertas',
                    },
                    component: () =>
                        import ('./views/ecommerce/checkout'),
                },
                {
                    path: '/ecommerce/checkout/cr',
                    meta: {
                        title: 'Criar Oferta',
                    },
                    component: () =>
                        import ('./views/ecommerce/checkout/create'),
                },
                /// ecommerce/checkout/${offerId}/edit
                {
                    path: '/ecommerce/checkout/create',
                    meta: {
                        title: 'Criar Oferta',
                    },
                    component: () =>
                        import ('./views/ecommerce/checkout/create'),
                },
                {
                    path: '/ecommerce/checkout/:id/edit',
                    meta: {
                        title: 'Editar Oferta',
                    },
                    component: () =>
                        import ('./views/ecommerce/checkout/edit'),
                },
                {
                    path: '/ecommerce/product',
                    meta: {
                        title: 'Produto',
                    },
                    component: () =>
                        import ('./views/ecommerce/product'),
                },
                // 404
                {
                    path: '/404',
                    meta: {
                        title: 'Error 404',
                    },
                    component: () =>
                        import ('./views/system/404'),
                },
            ],
        },
        {
            path: '/v2/orders',
            component: AppLayout,
            meta: { authRequired: true, hidden: true, authorizedRole: ['admin', 'support', 'owner'] },
            children: [{
                path: '',
                meta: {
                    title: 'Pedidos',
                    authRequired: true,
                },
                component: () =>
                    import ('./views/ecommerce/order/indexV2'),
            }],
        },
        {
            path: '/v2/orders/:id',
            component: AppLayout,
            meta: {
                authRequired: true,
                hidden: true,
                authorizedRole: ['admin', 'support', 'owner'],
            },
            children: [{
                path: '',
                meta: {
                    title: 'Pedidos',
                    authRequired: true,
                },
                component: () =>
                    import ('./views/ecommerce/order/view/indexV2'),
            }],
        },
        {
            path: '/orders',
            component: AppLayout,
            meta: { authRequired: true, hidden: true, authorizedRole: ['admin', 'support', 'owner'] },
            children: [{
                    path: '',
                    meta: {
                        title: 'Pedidos',
                        authRequired: true,
                    },
                    component: () =>
                        import ('./views/ecommerce/order'),
                },
                {
                    path: ':id',
                    meta: {
                        title: 'Ver Pedido',
                        authRequired: true,
                    },
                    component: () =>
                        import ('./views/ecommerce/order/view'),
                },
            ],
        },
        {
            path: '/register',
            meta: {
                title: 'Register',
            },
            component: () =>
                import ('./views/system/register'),
        },
        // System Pages
        {
            path: '/system',
            component: AuthLayout,
            redirect: '/system/login',
            children: [{
                    path: '/system/login',
                    meta: {
                        title: 'Login',
                    },
                    component: () =>
                        import ('./views/system/login'),
                },
                {
                    path: '/system/logout',
                    meta: {
                        title: 'Login',
                    },
                    component: () =>
                        import ('./views/system/logout'),
                },
                {
                    path: '/system/forgot-password',
                    meta: {
                        title: 'Forgot Password',
                    },
                    component: () =>
                        import ('./views/system/forgot-password'),
                },
                {
                    path: '/system/register',
                    meta: {
                        title: 'Register',
                    },
                    component: () =>
                        import ('./views/system/register'),
                },
                {
                    path: '/system/lockscreen',
                    meta: {
                        title: 'Lockscreen',
                    },
                    component: () =>
                        import ('./views/system/lockscreen'),
                },
                {
                    path: '/system/404',
                    meta: {
                        title: 'Error 404',
                    },
                    component: () =>
                        import ('./views/system/404'),
                },
                {
                    path: '/system/500',
                    meta: {
                        title: 'Error 500',
                    },
                    component: () =>
                        import ('./views/system/500'),
                },
            ],
        },
        {
            path: '*',
            redirect: 'system/404',
            hidden: true,
        },
    ],
})

router.beforeEach(authGuard)

export default router